import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import CInfoLangue from './CInfoLangue';

function CRegion(){  
  const paysIni = useSelector(state => state.ComPays)
  const regionIni = useSelector(state => state.ComRegion)
  const dispatch = useDispatch()
   const[showbtnvalider, setShowbtnvalider]=useState(false)
  const [showlangue, setShowLangue]=useState(false)
  const [lstregioninfo, SetLstregioninfo] = useState([]);
  const [selectRegion, setSelectRegion] = useState("");
  const [selectLangue, setSelectLangue] = useState("");
  const[query, SetQuery] = useState("");
  
  
  const onSelect = (event) =>{
      setSelectRegion(event.target.value);
      setSelectLangue(event.target.value);
      setShowLangue(false);       
      setShowbtnvalider(true);   
                
    }
    
    const actionbouton = () => {
          dispatch({ 
                  type:"ComRegion/sendCodeRegion",
                  payload: selectRegion
                  }); 

          setShowLangue(true)  
          console.log({selectRegion}) ;   
        //  console.log(selectRegion);         
    }
 
  ///let paramPays ='';
  /// paramPays = paysIni.codepays;
  const urlgetregioninfo = `https://eagrimet.online/eagrimetApi/regionInfo/?pays=${paysIni.codepays}`
  const  axiosconfig = {
        headers: {
        "Content-Type": "application/json",
        "Authorization": "Token f976960761d6c971c5be927bb45c4abfa1fcc352",
                 
        }
     };

   useEffect( () => {
        const cherchregioninfo = async() =>{
            await axios.get(urlgetregioninfo, axiosconfig)           
           .then((resultat) => {
                SetLstregioninfo(resultat.data);
                console.log("resultat trouvé");
             }
            ) 
           .catch((err) => console.log(err));  
        };
        cherchregioninfo()
     }, [paysIni.codepays, query])  



    return (
      <div className='mx-auto row '>  
          <div className='col-6' >       
                <label hidden htmlFor="idregion">Pays {paysIni.codepays} - {regionIni.coderegion} </label>               
                <select className='form-select' name="regionlst" id="idregion" onChange={onSelect} value={selectRegion} >
                  {
                    lstregioninfo.map((rinfo) => { return ( <option key={rinfo.code} value={rinfo.code}>{rinfo.region}</option> )}
                  )}
                </select>            
          </div>
          <div className='col-6' >  
                { showbtnvalider && <button className='btn btn-success' onClick={actionbouton}>{paysIni.labelbouton2} <i className='bi bi-volume-up'></i></button > }
          </div>

      { showlangue &&
        <div className='espacehautbas'>
          <CInfoLangue/>
        </div>  
      }
      
      </div>

    );
  }

 
export default CRegion; 